import { app } from '../../app.module'
app
  // Twitter投稿テーブルの平均値
  .directive('postTwitterTableAverage', () => {
    return {
      restrict: 'EA',
      template: require('./post-twitter-table-average.pug')(),
      controller: function ($scope) {
        $scope.$watch(
          () => {
            return $scope.postsDataAverage
          },
          () => {
            if ($scope.postsDataAverage !== undefined) {
              // インプレッションの平均
              $scope.impressionsAverage =
                $scope.postsDataAverage.impressions / $scope.query.postsCount
              // いいねの平均
              $scope.likesAverage = $scope.postsDataAverage.likes / $scope.query.postsCount
              // リポストの平均
              $scope.retweetsAverage = $scope.postsDataAverage.retweets / $scope.query.postsCount
              // 返信の平均
              $scope.repliesAverage = $scope.postsDataAverage.replies / $scope.query.postsCount
              // 引用の平均
              $scope.quotesAverage = $scope.postsDataAverage.quotes / $scope.query.postsCount
              // 反応数の平均
              $scope.engagementsAverage =
                $scope.postsDataAverage.engagements / $scope.query.postsCount
              // 反応率の平均
              $scope.engagementRateAverage =
                $scope.postsDataAverage.engagementRates / $scope.query.postsCount
            }
          }
        )
      },
    }
  })
